<template>
  <side-bar>
    <template slot="links">
      <div class="container px-2" role="tablist">
        <router-link
          :to="{ name: 'inicio' }"
          class="navbar-item d-block position-relative"
          role="tab"
        >
          <span>
            <font-awesome-icon icon="house" />
          </span>
          Início
          <circle-alert class="position-absolute top-0" />
        </router-link>

        <div
          v-for="(link_child, key) in plataforma"
          :key="key"
          class="navbar-item"
          role="tab"
        >
          <div
            v-b-toggle="'sidebar-item-' + key"
            class="sidebar-item-parent d-inline-flex w-100 align-items-center"
          >
            <span>
              <font-awesome-icon :icon="link_child.icon" />
            </span>
            {{ link_child.label }}

            <font-awesome-icon icon="angle-down" class="ml-auto on-closed" />
            <font-awesome-icon icon="angle-up" class="ml-auto on-opened" />
          </div>

          <b-collapse
            :id="'sidebar-item-' + key"
            accordion="sidebar-menu"
            role="tabpanel"
            class="navbar-item-submenu"
          >
            <div
              v-for="(link_child, key) in link_child.childrens"
              :key="key + 'second_key'"
            >
              <b-nav-item v-if="!!link_child.to" :to="{ name: link_child.to }">
                <font-awesome-icon icon="angle-right" class="mr-2" />
                {{ link_child.label }}
              </b-nav-item>
            </div>
          </b-collapse>
        </div>
      </div>
    </template>
  </side-bar>
</template>

<script setup>
import CircleAlert from "@/modules/config/components/Home/CircleAlert.vue";

const plataforma = [
  {
    label: "Oportunidades",
    icon: "lightbulb",
    class: "nav-item-icon text-white",
    childrens: [
      {
        label: "Oportunidades",
        to: "oportunidades_list",
        icon: "",
        class: "nav-item-icon text-white",
      },
      {
        label: "Importação de recursos",
        to: "oportunidades_import_select",
        icon: "",
        class: "nav-item-icon text-white",
      },
      {
        label: "Concedentes",
        to: "concedentes_list",
        icon: "",
        class: "nav-item-icon text-white",
      },
      {
        label: "Biblioteca de Arquivos",
        to: "files_list",
        icon: "",
        class: "nav-item-icon text-white",
      },
    ],
  },
  {
    label: "Cadastros Complementares",
    icon: "table",
    class: "nav-item-icon text-white",
    childrens: [
      {
        label: "Áreas",
        to: "areas_list",
        icon: "map-marked-alt",
        class: "nav-item-icon text-white",
      },
      { label: "Categorias", to: "categorias_list", icon: "", class: "" },
      {
        label: "Modelos de Contrapartidas",
        to: "contrapartidas_list",
        icon: "",
        class: "text-white",
      },
      {
        label: "Origens",
        to: "tipos_concedentes_list",
        icon: "",
        class: "text-white",
      },
      {
        label: "Tipos de Instituições",
        to: "tipos_instituicoes_list",
        icon: "",
        class: "text-white",
      },
      {
        label: "Tipos de instrumentos",
        to: "tipos_instrumentos_list",
        icon: "",
        class: "text-white",
      },
      {
        label: "Moedas",
        to: "moedas_list",
        icon: "",
        class: "text-white",
      },
      {
        label: "Perguntas Frequentes",
        to: null,
        icon: "",
      },
    ],
  },
  {
    label: "Gestão de Parceiros",
    icon: "user-group",
    class: "text-info",
    childrens: [
      { label: "Visão Geral", to: "", icon: "", class: "" },
      { label: "Parceiros", to: "parceiros_list", icon: "", class: "" },
      {
        label: "Usuários",
        to: "users_list",
        icon: "",
        class: "",
      },
      {
        label: "Clientes",
        to: "clientes_list",
        icon: "",
        class: "",
      },
    ],
  },
  {
    label: "Gestão de Assinaturas",
    icon: "signature",
    class: "text-orange ",
    childrens: [
      // {
      //   label: "Assinaturas",
      //   to: "assinaturas_list",
      //   icon: "",
      //   class: "",
      // },
      { label: "Planos", to: "planos_list", icon: "", class: "" },
      { label: "Pedidos", to: "pedidos_list", icon: "", class: "" },
      // { label: "Tipos de Acesso", to: "", icon: "", class: "" },
      // { label: "Visão Geral / Relatórios", to: "", icon: "", class: "" },
    ],
  },
  {
    label: "Extratores",
    icon: "file-signature",
    class: "text-yellow",
    childrens: [
      {
        label: "Discricionárias e Legais",
        to: "extratores_list",
        icon: "",
        class: "",
      },
    ],
  },
  {
    label: "Ferramentas",
    icon: "wrench",
    class: "text-green ",
    childrens: [
      { label: "Relatorios", to: "relatorios_list", icon: "", class: "" },
      { label: "Envio de E-mail", to: "", icon: "", class: "" },
      { label: "MailGun", to: "", icon: "", class: "" },
      { label: "Google Analytics", to: "", icon: "", class: "" },
      { label: "Suporte Bag Sistemas", to: "", icon: "", class: "" },
    ],
  },
  {
    label: "Administração",
    icon: "user-shield",
    class: "blue-grey ",
    childrens: [
      {
        label: "Configurações",
        to: "assinaturas_configuracoes",
        icon: "",
        class: "",
      },
      {
        label: "Termos de filtros",
        to: "termos_filtros_list",
        permission: "traducoes:view",
        icon: "",
        class: "",
      },
      {
        label: "Usuários Administrativos",
        to: "users_list_admin",
        icon: "",
        class: "",
      },
      {
        label: "Perfis de Usuários",
        to: "acl_list",
        icon: "",
        class: "",
      },
      {
        label: "CNPJ",
        to: "cnpjs_list",
        icon: "",
        class: "",
      },
    ],
  },
];
</script>
